import { Coordinate2D } from "./Coordinate";

export enum EMaskShape {
  Ellipse = 0,
  Rectangle = 1,
  RoundedRectangle = 2,
}

export enum EMaskShapeExtended {
  Ellipse = 0,
  Rectangle = 1,
  RoundedRectangle = 2,
  Circle = 3,
  Square = 4,
  RoundedSquare = 5,
}

export enum EMaskHandle {
  NONE,
  TOP,
  RIGHT,
  LEFT,
  BOTTOM,
  ROUND,
  BODY,
}

export interface MaskBounding {
  centerPoint: Coordinate2D;
  width: number;
  height: number;
}

export interface ImageMaskInPixel {
  shape: EMaskShape;
  width: number;
  height: number;
  centerXOffset: number;
  centerYOffset: number;
  radius: number;
}

export interface ImageMask {
  shape: EMaskShape;
  widthInMicrons: number;
  heightInMicrons: number;
  centerXOffsetInMicrons: number;
  centerYOffsetInMicrons: number;
  radiusForRoundedEdgesInMicrons: number;
}

export interface CanvasSize{
  width : number;
  height: number;
}
